import { render, staticRenderFns } from "./ChevronDownSvg.vue?vue&type=template&id=52bbac46"
import script from "./ChevronDownSvg.vue?vue&type=script&lang=js"
export * from "./ChevronDownSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports